import { buildApiUrl } from '@/config/apiBaseUrl';
import { getJsonAuthHeaders } from './authHeaders';

import type { SharedOffer } from '../../functions/src/publicOfferContract';
export type { SharedOffer } from '../../functions/src/publicOfferContract';

async function request<T>(action: string, body: Record<string, string>): Promise<T> {
  const response = await fetch(buildApiUrl(`/api/offers/${action}`), {
    method: 'POST', headers: await getJsonAuthHeaders(), body: JSON.stringify(body),
  });
  if (!response.ok) throw new Error(response.status === 401 ? 'Zaloguj się, aby zaakceptować ofertę.' : 'Oferta niedostępna. Poproś wykonawcę o aktualny link.');
  return response.json() as Promise<T>;
}
export async function publishSharedOffer(projectId: string): Promise<string> {
  const { token } = await request<{ token: string }>('publish', { projectId });
  return `${window.location.origin}/offer/shared#${token}`;
}
export const readSharedOffer = (token: string) => request<{ offer: SharedOffer }>('read', { token });
export const acceptSharedOffer = (token: string) => request('accept', { token });
